import { useRef, useState } from "react";
import { ChatSummaryIcon } from "../../Assets/svgs/ChatSummaryIcon";
import { useSelector } from "react-redux";

export const ChatSummaryPopup = ({
  summary,
  onClose,
  onClickOriginalMsg,
  isFromCallHistory,
}) => {
  const reference = useRef();
  const [copySuccess, setCopySuccess] = useState(false);
  const onCopy = (e) => {
    // reference.current.select();
    const text = reference.current.innerText;
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
    setCopySuccess(true);
  };

  return (
    <div className="modal modal--createAssistant modal--open">
      <div className="modal__dialog">
        <div className="modal__content modal__content--lg">
          <div className="modal__header">
            <h1 className="modal__header--title">Summarize Conversation</h1>
            <p className="para">
              Let’s customize your assistant! You can simply focus on the
              summary of the conversation between Customer and Assistant
            </p>
            <button className="btn btn__transparent btnClose" onClick={onClose}>
              <svg
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.586914"
                  width="24"
                  height="24"
                  rx="12"
                  fill="#E5E5E5"
                />
                <path
                  d="M12.5869 10.8891L16.476 7L17.5869 8.11094L13.6979 12L17.5869 15.8891L16.476 17L12.5869 13.1109L8.69785 17L7.58691 15.8891L11.476 12L7.58691 8.11094L8.69785 7L12.5869 10.8891Z"
                  fill="#4F4F4F"
                />
              </svg>
            </button>
          </div>
          <div className="modal__body modal__body--summarizeConversation modal-body-left">
            <h3 className="title">
              <ChatSummaryIcon />
              Summary
            </h3>
            <p className="para" ref={reference}>
              {summary}
            </p>
            <p className="para" onClick={onCopy}>
              <button className="btn">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.31038 3.56304V3.56304C9.31038 3.28903 9.31038 3.15202 9.2961 3.0369C9.19021 2.18327 8.51774 1.5108 7.66411 1.40491C7.54899 1.39062 7.41198 1.39062 7.13797 1.39062H4.88509C3.24514 1.39062 2.42516 1.39062 1.8908 1.86815C1.83843 1.91495 1.78873 1.96466 1.74193 2.01702C1.2644 2.55138 1.2644 3.37136 1.2644 5.01131V6.21821C1.2644 6.71683 1.2644 6.96614 1.31147 7.17237C1.47195 7.87545 2.02096 8.42446 2.72404 8.58493C2.93027 8.632 3.17958 8.632 3.6782 8.632V8.632"
                    stroke="#475569"
                    stroke-width="1.12644"
                  />
                  <rect
                    x="5.48853"
                    y="5.61523"
                    width="7.04023"
                    height="7.04023"
                    rx="1.87739"
                    stroke="#475569"
                    stroke-width="1.12644"
                  />
                </svg>
                {copySuccess ? "Copied" : "Copy"}
              </button>
            </p>
            {!isFromCallHistory ? (
              <p className="para mb_0">
                <a className="link" onClick={onClickOriginalMsg}>
                  View Original Messages
                </a>
              </p>
            ) : null}
          </div>
        </div>
      </div>
      <div className="modal__backdrop"></div>
    </div>
  );
};
